import { createSyncStoragePersister } from "@tanstack/query-sync-storage-persister";
import { QueryClient } from "@tanstack/react-query";
import { persistQueryClient } from "@tanstack/react-query-persist-client";
import { AxiosError } from "axios";

declare module "@tanstack/react-query" {
    interface Register {
        defaultError: AxiosError;
    }
}

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            staleTime: 30 * 1000,
            // Disable cross-tab synchronization
            refetchOnReconnect: false,
        }
    },
});

const localStoragePersister = createSyncStoragePersister({
    storage: window.localStorage,
});
// const sessionStoragePersister = createSyncStoragePersister({ storage: window.sessionStorage })

persistQueryClient({
    queryClient,
    persister: localStoragePersister,
});

export default queryClient;
